import simpleFetch from "../../../../../utils/simpleFetch";

class DataApi {
  static updateProvinces(model, body, headers) {
    return simpleFetch("PUT", model.path, { body, headers });
  }
  static updateAccountBusinessUnit(model, body, headers) {
    return simpleFetch("PUT", model.path, { body, headers });
  }

  static getAccounts(headers) {
    return simpleFetch("GET", "/v1/accounts", { headers });
  }

  static updateAccounts(body, headers) {
    return simpleFetch("PATCH", "/v1/accounts", { body, headers });
  }
}

export default DataApi;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/accountsApi.js